module.exports = __webpack_public_path__ + "img/full_heart.40e64026.svg";